import React, { useContext, useState } from "react";

import './styles.css';

import TextInput from '../../TextInput/TextInput';
import LinearLoader from "../../Loader/LinearLoader";
import { useNavigate } from "react-router-dom";
import UserContext from "contexts/UserContext";

function ForgotPassword({
    user, setUser, emailWarning, onClick, nav, loading, isSent
}) {
    const { currentPromo } = useContext(UserContext);
    const [type, setType] = useState('email');
    const navigate = useNavigate();

    return (
        isSent ? <>
            <div className="forgot-password-container">
                <h1>E-mail enviado</h1>
                <div className="forgot-password-card">
                    <div className="forgot-password-form-container">
                        <p className="forgot-password-form-subtitle">Enviamos um link de redefinição de senha para o seu {type === 'email' ? 'e-mail' : 'telefone'} cadastrado.</p>
                        <button className="forgot-password-form-button" onClick={() => navigate(`/${currentPromo.path}/login`)}>Voltar</button>
                    </div>
                </div>
            </div> :
        </> :
            <form className="forgot-password-container">
                <h1>Esqueci minha senha</h1>
                <div className="forgot-password-card">
                    <div className="forgot-password-form-container">
                        <p className="forgot-password-form-title">Vamos te ajudar!</p>
                        <p className="forgot-password-form-subtitle">
                            <br/>
                            <small>
                                Informe seu e-mail ou documento e, caso encontremos seu cadastro, enviaremos um link para redefinição de senha.
                            </small>
                        </p>
                        <div className="forgot-password-form-inputs-container">
                            <TextInput
                                label={<span className="black-label">Insira seu e-mail, CPF ou CNPJ</span>}
                                value={user}
                                setValue={setUser}
                                warningMessage={emailWarning}
                            />
                        </div>
                        <button type="button" className="forgot-password-form-button" onClick={() => { setType('email');  onClick('email') }}>
                            {loading ? <LinearLoader white /> : <p>Enviar por email</p>}
                        </button>
                        <button type="button" className="forgot-password-form-button" onClick={() => { setType('phone'); onClick('phone') }}>
                            {loading ? <LinearLoader white /> : <p>Enviar por SMS</p>}
                        </button>

                        <p className="forgot-password-form-subtitle">
                            Lembrou sua senha? <span className="create-account" onClick={nav}>Volte e logue aqui</span>
                        </p>
                    </div>
                </div>
            </form>
    )
}

export default ForgotPassword;